window.addEventListener("load", function () {
  let _learnq = window._learnq || [];
  function cartUpdated(productToRemove) {
    fetch(`${window.location.origin}/cart.js`).then((res) =>
      res
        .clone()
        .json()
        .then((cart) => {
          _learnq.push(["track", "Cart updated", cart]);
        }),
    );
  }

  (function (ns, fetch) {
    ns.fetch = function () {
      const response = fetch.apply(this, arguments);
      response.then((res) => {
        if (
          `${window.location.origin}/cart/add.js`.includes(res.url) ||
          `${window.location.origin}/cart/change.js`.includes(res.url)
        ) {
          cartUpdated();
        }
      });
      return response;
    };
  })(window, window.fetch);

  let atcButtons = document.querySelectorAll(
    "form[action*='/cart/add'] button[type='submit'], a[href*='/cart/change']",
  );
  for (let i = 0; i < atcButtons.length; i++) {
    atcButtons[i].addEventListener("click", function () {
      // _learnq.push(['track', 'Added to Cart', item]);
      cartUpdated();
    });
  }
});
